import { RichTextProps } from '@uikit/components/RichText/interfaces';
import RichText from '@uikit/components/RichText/RichText';
import styles from './PressArticleRichText.module.scss';

const PressArticleRichText = (props: RichTextProps) => {
  return <RichText {...props} className={styles.base} />;
};

export default PressArticleRichText;
